/* Costack sticky mobile add-to-cart - 23 Jun 2026 (v2: scroll-based toggle)
 * Shows a fixed bottom bar (price + Add to cart) whenever the real buy button
 * is out of view, on mobile/tablet only. The bar's button clicks the real
 * product-form submit, so variant, quantity and the cart drawer all keep
 * working. Self-contained: injects its own CSS. Supersedes the dead
 * .costack-satc bar that was stuck at display:none.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  var CSS = [
    '.costack-satc{display:none !important;}',
    '#cstk-satc{position:fixed;left:0;right:0;bottom:0;z-index:9997;display:flex;align-items:center;gap:12px;',
    'padding:9px 14px;padding-bottom:calc(9px + env(safe-area-inset-bottom));background:#fffaf2;',
    'border-top:1px solid #f0d089;box-shadow:0 -4px 16px rgba(0,0,0,.12);',
    'transform:translateY(120%);transition:transform .28s ease;font-family:inherit;}',
    '#cstk-satc.is-on{transform:translateY(0);}',
    '#cstk-satc.is-hide{transform:translateY(120%) !important;}',
    '#cstk-satc .cstk-satc__i{display:flex;flex-direction:column;min-width:0;flex:1 1 auto;}',
    '#cstk-satc .cstk-satc__t{font-size:12.5px;font-weight:600;color:#231900;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '#cstk-satc .cstk-satc__p{font-size:14px;font-weight:700;color:#b3641c;line-height:1.2;}',
    '#cstk-satc .cstk-satc__b{flex:0 0 auto;border:0;border-radius:8px;cursor:pointer;background:#b3641c;color:#fff;',
    'font-weight:700;font-size:15px;padding:12px 24px;min-height:48px;font-family:inherit;transition:background .15s ease;}',
    '#cstk-satc .cstk-satc__b:hover{background:#9a5314;}',
    '#cstk-satc .cstk-satc__b[disabled]{background:#c9bda8;cursor:not-allowed;}',
    '@media(min-width:990px){#cstk-satc{display:none !important;}}'
  ].join('');

  function init() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    var realBtn = form && (form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]'));
    if (!realBtn || document.getElementById('cstk-satc')) return;

    var style = document.createElement('style');
    style.id = 'cstk-satc-css';
    style.textContent = CSS;
    document.head.appendChild(style);

    var titleEl = document.querySelector('.product__title, h1');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';

    var bar = document.createElement('div');
    bar.id = 'cstk-satc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var info = document.createElement('div');
    info.className = 'cstk-satc__i';
    var t = document.createElement('span');
    t.className = 'cstk-satc__t';
    t.textContent = title;
    var p = document.createElement('span');
    p.className = 'cstk-satc__p';
    info.appendChild(t);
    info.appendChild(p);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cstk-satc__b';

    bar.appendChild(info);
    bar.appendChild(b);
    document.body.appendChild(bar);

    function priceText() {
      var el = document.querySelector('.price__sale .price-item--sale')
        || document.querySelector('.price__regular .price-item--regular')
        || document.querySelector('.price-item--regular')
        || document.querySelector('.price-item');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function sync() {
      var off = !!realBtn.disabled;
      b.disabled = off;
      b.textContent = off ? 'Sold out' : 'Add to cart';
      p.textContent = priceText();
    }
    sync();

    b.addEventListener('click', function () {
      if (!realBtn.disabled) realBtn.click();
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-form, .product-form, variant-selects, variant-radios')) {
        setTimeout(sync, 80);
      }
    });
    document.documentElement.addEventListener('cart:refresh', function () { setTimeout(sync, 80); });

    function show(v) { bar.classList.toggle('is-on', v); }
    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight - 40) && r.bottom > 0;
    }
    function update() { show(!inView(realBtn)); }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    setTimeout(update, 600);

    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        bar.classList.toggle('is-hide', drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Costack bundle-first PDP: "Shop our sets" strip - 23 Jun 2026
 * High-placement merchandising under the buy box. Pulls in-stock products from
 * the bundles collection live (no hardcoding), shows a FREE UK delivery badge
 * only on sets that clear the £35 threshold, links to each set + the collection.
 * Product-page only. Self-contained CSS.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var FREE_PENCE = 3500;

  var CSS = [
    '.cstk-sets{margin:18px 0 6px;}',
    '.cstk-sets__headrow{display:flex;align-items:baseline;justify-content:space-between;margin:0 0 10px;}',
    '.cstk-sets__head{font-size:14px;font-weight:700;color:#231900;}',
    '.cstk-sets__all{font-size:12.5px;color:#b3641c;text-decoration:underline;white-space:nowrap;}',
    '.cstk-sets__scroll{display:flex;gap:10px;overflow-x:auto;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;padding-bottom:4px;}',
    '.cstk-sets__scroll::-webkit-scrollbar{height:0;}',
    '.cstk-sets__card{flex:0 0 150px;scroll-snap-align:start;border:0.5px solid #ecdfc8;border-radius:10px;padding:8px;text-decoration:none;color:#231900;background:#fff;}',
    '.cstk-sets__imgwrap{height:96px;border-radius:7px;overflow:hidden;background:#f5f1ea;margin-bottom:7px;}',
    '.cstk-sets__imgwrap img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.cstk-sets__t{font-size:12px;font-weight:600;line-height:1.3;min-height:31px;}',
    '.cstk-sets__p{font-size:13px;font-weight:700;color:#b3641c;margin-top:4px;}',
    '.cstk-sets__free{display:inline-block;margin-top:5px;font-size:10.5px;font-weight:700;color:#1f7a37;background:#e9f8ec;border-radius:5px;padding:2px 6px;}'
  ].join('');

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=300';
  }

  function init() {
    var form = document.querySelector('product-form, .product-form');
    if (!form || document.querySelector('.cstk-sets')) return;

    fetch('/collections/bundles/products.json?limit=20', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) {
          return (p.variants || []).some(function (v) { return v.available; });
        }).slice(0, 8);
        if (!prods.length) return;

        var style = document.createElement('style');
        style.textContent = CSS;
        document.head.appendChild(style);

        var wrap = document.createElement('div');
        wrap.className = 'cstk-sets';

        var headRow = document.createElement('div');
        headRow.className = 'cstk-sets__headrow';
        var head = document.createElement('span');
        head.className = 'cstk-sets__head';
        head.textContent = 'Buy a set, save on delivery';
        var all = document.createElement('a');
        all.className = 'cstk-sets__all';
        all.href = '/collections/bundles';
        all.textContent = 'Shop all sets';
        headRow.appendChild(head);
        headRow.appendChild(all);

        var scroll = document.createElement('div');
        scroll.className = 'cstk-sets__scroll';

        prods.forEach(function (p) {
          var v = (p.variants || [])[0] || {};
          var pricePence = Math.round(parseFloat(v.price || '0') * 100);
          var free = pricePence >= FREE_PENCE;
          var img = (p.images && p.images[0]) ? p.images[0].src : '';
          var card = document.createElement('a');
          card.className = 'cstk-sets__card';
          card.href = '/products/' + p.handle;
          card.innerHTML =
            '<div class="cstk-sets__imgwrap">' + (img ? '<img loading="lazy" decoding="async" src="' + imgUrl(img) + '" alt="">' : '') + '</div>'
            + '<div class="cstk-sets__t">' + esc(p.title) + '</div>'
            + '<div class="cstk-sets__p">£' + parseFloat(v.price || '0').toFixed(2) + '</div>'
            + (free ? '<div class="cstk-sets__free">FREE UK delivery</div>' : '');
          scroll.appendChild(card);
        });

        wrap.appendChild(headRow);
        wrap.appendChild(scroll);

        var anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-form') || form;
        var host = anchor.parentNode || form.parentNode;
        if (host) host.insertBefore(wrap, anchor.nextSibling);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
